import { render, staticRenderFns } from "./PackagingBox.vue?vue&type=template&id=2db50937"
import script from "./PackagingBox.vue?vue&type=script&lang=js"
export * from "./PackagingBox.vue?vue&type=script&lang=js"
import style0 from "./PackagingBox.vue?vue&type=style&index=0&id=2db50937&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports